import React, {  useState } from 'react';

const PersonalError = ({ errors, touched, name }) => {
  const [showError, setShowError] = useState(true);
 
  const error = errors?.[name];
  const isTouched = touched?.[name];

  const toggleError = () => setShowError((prev) => !prev);

  if (!isTouched) return null;

  return (
    <div className="validate-container ">
      <i
        className={
          error
            ? "fa fa-exclamation-triangle text-danger"
            : "fa fa-check text-success"
        }
        aria-hidden="true"
        style={{ cursor: 'pointer', zIndex: 5, position: "relative" }}
        onClick={toggleError}
      />
      {error && (
        <span
          className="text-danger validate-span"
          style={{ display: showError ? 'inline' : 'none' }}
        >
          {error}
        </span>
      )}
    </div>
  );
};

export default PersonalError;
